const queryParameters = new URLSearchParams(window.location.search);

export default function getQueryParameter(name, defaultValue) {
  return queryParameters.get(name) || defaultValue;
}
